<template xmlns:v="http://www.w3.org/1999/XSL/Transform">
    <templateItem
        v-bind:metadata="metadata"
        v-bind:isSelected="isSelected"
        v-bind:parentId="parentId"
        v-bind:classes="classes"
        v-bind:styles="style"
        v-bind:controlsStyle="'right: -29px; top: -22px;'"
        v-on:delete-item="$emit('delete-row', $event)"
        v-on:select-item="$emit('select-row', $event)"
        v-on:move-item="$emit('move-row', $event)"
        v-on:lock-item="$emit('lock-row', $event)"
        v-on:unselect-all="selectedColumn = null"
        v-bind:isParent="isParent"
        v-bind:locked="locked"
    >

        <template v:slot="settings" v-if="showSettings">
            <TemplateRowSettings
                v-bind:color="metadata.style.color"
                v-on:change-color="$emit('change-color', $event)"
            />
        </template>

        <div 
            v-if="columnsReady" 
            class="row"
        >
            <div
                v-for="(column, i) in rowType.Value.columns"
                v-bind:class="column"
                v-bind:key="column.id"
            >
                <templateColumn
                    ref="columns"
                    v-if="orderedColumns[i] != null"
                    v-bind:id="orderedColumns[i].Id"
                    v-bind:parentId="orderedColumns[i].ParentId"
                    v-bind:currentTemplateId="currentTemplateId"
                    v-bind:templateId="orderedColumns[i].TemplateId"
                    v-bind:key="orderedColumns[i]._key"
                    v-bind:rowId="orderedColumns[i].RowId"
                    v-bind:metadata="orderedColumns[i].Metadata"
                    v-bind:columnTypeId="orderedColumns[i].ColumnTypeId"
                    v-bind:columnTypes="columnTypes"
                    v-bind:parentColor="metadata.style.color"
                    v-bind:isSelected="selectedColumn === orderedColumns[i]"
                    v-bind:locked="orderedColumns[i].IsLocked"
                    v-bind:lockStateChanged="orderedColumns[i].LockStateChanged"
                    v-on:delete-column="deleteColumn($event)"
                    v-on:select-column="selectedColumn = orderedColumns[i]"
                    v-on:lock-column="toggleColumnLock(orderedColumns[i], $event)"
                    v-on:item-added="$emit('item-added')"
                    @metadata-changed="setMetadata(orderedColumns[i], $event)"
                >
                </templateColumn>

                <div v-else class="row">
                    <div v-if="!lockedByParent" class="col-auto mx-auto">
                        <a 
                            href="javascript:void(0)" 
                            class="mdb-icon-btn new" 
                            data-toggle="tooltip"
                            v-bind:title="tooltips.insertColumn"
                            v-on:click.stop="pickingColumn = { index: i }"
                        >
                            <i class="fa fa-plus-circle fa-2x"></i>
                        </a>

                        <div 
                            v-if="pickingColumn.index === i" 
                            class="item-picker text-center"
                            v-on:mouseleave="pickingColumn = {}"
                        >
                            
                            <div class="row">
                                <div class="col-12 item-picker-header">
                                    <span>
                                        {{resource('TemplateRow_ColumnTypePicker_Title')}}
                                    </span>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 item-picker-content">
                                    
                                    <table width="100%">
                                        <tr 
                                            v-for="column in columnTypes"
                                            v-bind:id="column.Id"
                                            v-bind:key="column.Id"
                                        >
                                            <td>
                                                <div 
                                                    class="item-picker-column" 
                                                    v-on:click.stop="addColumn(i, column.Id)">
                                                    
                                                    <h5>
                                                        <b>{{column.Value.name}}</b>
                                                    </h5>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </templateItem>
</template>

<script>
    import {autoInitializeTooltips as autoInitializeTooltipsMixin} from "../../../Util/Mixins/tooltips";

    import {applyDefaults, columnDefaults} from "../defaults";

    import {insertColumnTooltip} from "../tooltips";
    import selectableItemMixin from '../Mixins/selectable-item';
    import resourceMixin from "../../../Util/Mixins/resources";
    import guidMixin from '../../../Util/Mixins/guid';
    
    import Column from './TemplateColumn.vue';
    import TemplateItem from './TemplateItem.vue';
    import TemplateRowSettings from './Settings/TemplateRowSettings.vue';
    import templateApi from '../../../Api/template-manager';

    export default {
        name: 'template-column',
        mixins: [resourceMixin, autoInitializeTooltipsMixin, guidMixin, selectableItemMixin],
        components: {
            'TemplateColumn': Column,
            'TemplateItem': TemplateItem,
            'TemplateRowSettings': TemplateRowSettings
        },
        created () {
            const vm = this;

            templateApi.getColumnTypes().then((columnTypes) => {
                vm.columnTypes = columnTypes;
            });
        },
        methods: {
            getColumn(index) {
                return this.columns.find((column) => { return column.Metadata.index == index+1 });
            },
            addColumn(index, id) {
                const vm = this;
                const key = vm.guid();

                let column = {
                    _key: key,
                    ColumnTypeId: id,
                    RowId: vm.id,
                    TemplateId: vm.currentTemplateId,
                    IsLocked: false,
                    LockStateChanged: false,
                    Metadata: {
                        index: index+1,
                        contentSettings: {}
                    }
                };

                applyDefaults(columnDefaults, column.Metadata);
                
                vm.columns.splice(index, 0, column);
                vm.pickingColumn = {};

                vm.$nextTick(function () {
                    const columnRef = vm.$refs.columns.find((column) => { 
                        return column.$vnode.key == key
                    });
                    
                    columnRef.emitSelectItem();
                });

                this.$emit('item-added');
            },
            toggleColumnLock(column, locked) {
                column.IsLocked = locked;
                column.LockStateChanged = !column.LockStateChanged;
            },
            deleteColumn(index) {
                const columns = this.columns;
                let targetIndex;

                columns.forEach(function (column) {
                    if(column.Metadata.index === index) {
                        targetIndex = columns.indexOf(column);
                    }
                });

                if(targetIndex !== undefined)
                    columns.splice(targetIndex,1);
            },
            setMetadata(column, metadata){
                const vm = this;
                
                Object.keys(metadata).forEach(k => {
                    column.Metadata[k] = metadata[k];
                });
                
                vm.$set(
                    vm.columns,
                    vm.columns.indexOf(column),
                    column
                );
            }
        },            
        watch: {
            selectedColumn(value){
                //Upon selecting a column, also select the row
                if(value){
                    this.emitSelection('select-row', this.metadata);
                }
            }
        },
        computed: {
            lockedByParent() {
                return this.locked && this.isParent;
            },
            showSettings() {
                return this.isSelected && !this.lockedByParent;
            },
            columnsReady() {
                return this.columnTypes != null;
            },
            rowType() {
                const vm = this;

                return vm.rowTypes.find((type) => { 
                    return type.Id == vm.rowTypeId; }
                );
            },
            orderedColumns(){
                const vm = this;
                
                return vm.rowType.Value.columns.reduce((acc, cur, idx) => {
                    const column = vm.getColumn(idx);
                    
                    acc.push(column);
                    
                    return acc;
                }, []);
            },
            backgroundColor() {
                return this.metadata.style.color != '' ? this.metadata.style.color : this.parentColor;
            },
            style() {
                return `background-color: ${this.backgroundColor};`;
            },
            isParent() {
                return this.currentTemplateId.toLowerCase() !== this.templateId.toLowerCase();
            },
            classes(){
                const classList = [
                    'mx-auto',
                    'template-row'
                ];

                if(this.isSelected){
                    classList.push('selected-row');
                }

                return classList.join(' ');
            },

        },
    	data() { 
            return {
                tooltips: {
                    insertColumn: insertColumnTooltip
                },
                
                selectedColumn: null,
                pickingColumn: {},
                columnTypes: null
            };
        },
        props: {
            id: {
                type: String,
                required: false
            },
            parentId: {
                type: String,
                default: null
            },
            locked: {
                type: Boolean,
                default: false
            },
            lockStateChanged: {
                type: Boolean,
                required: true
            },
            isSelected: {
                type: Boolean,
                required: true
            },
            currentTemplateId: {
                type: String,
                required: true
            },
            templateId: {
                type: String,
                required: true
            },
            currentTemplateId: {
                type: String,
                required: true
            },
            templateId: {
                type: String,
                required: true
            },
            blockId: {
                type: String,
                required: false
            },
            rowTypes: {
                type: Array,
                required: true
            },
            rowTypeId: {
                type: String,
                required: true
            },
            metadata: {
                type: Object,
                required: true,
                default: function () {
                    return { 
                        index: 0,
                        contentSettings: {}
                    }
                }
            },
            columns: {
                type: Array,
                required: true
            },
            parentColor: {
                type: String,
                default: function () {
                    return '#ffffff';
                }
            }
        }
    };
</script>

<style scoped src="../Style/template-row.scss" lang="scss">
</style>
